<style lang="stylus" scoped>
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
}

.demonstration {
  margin-right: 15px;
}

.mark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;

  .circle {
    margin: auto;
  }
}

.carWrap {
  // display: flex;
  // flex-direction: column;
  // padding: 20px;
  background: #fff;
  border-radius: 10px;

  main {
    flex: 1;
  }
}
.statiscs-time /deep/ .el-form-item__content{
  width: 140px;
}
</style>
<template>
  <div>
    <dimension-dialog v-if="showExport" @hideExport="hideExport1" :oilBrand="oilBrand" :provinceName="provinceNames" :cityName="cityName" :moduleName="moduleName" :beforeExportFunc="beforeExportFunc"/>
    <div style class="carWrap">
      <Top100CompanyTable :id="poiId" @on-close="showTop100Company = false" v-if="showTop100Company" :dimObj="dimObj"/>
      <div v-show="!showTop100Company">
        <div class>
          <el-form :inline="true" class="formSerch">
            <el-form-item label="统计时间" class="statiscs-time">
              <dimension-popover :isMapValue="true" :dimObj="dimObj" :change="changeDimension" :showBottomButton="false" :isItemBindClick="true" />
            </el-form-item>
            <el-form-item label="省份">
              <el-select v-model="provinceNames" placeholder="请选择省份" @change="getCityList">
                <el-option label="全部" value></el-option>
                <el-option v-for="item in areaList" :label="item.provinceName" :value="item.provinceName" :key="item.provinceName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="地区">
              <el-select v-model="cityName" placeholder="请选择地区" @change="getCityName">
                <el-option label="全部" value></el-option>
                <el-option v-for="item in cityData" :label="item.cityName" :value="item.cityName" :key="item.cityName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="品牌">
              <el-select v-model="oilBrand" placeholder="请选择品牌" @change="getBrandCode">
                <el-option v-for="item in titleArr" :label="item.name" :value="item.name" :key="item.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item style="margin-left: 20px;">
              <el-button @click="submitData">查询</el-button>
              <el-button @click="goback">返回上一级</el-button>
              <el-button v-show="hideExport" @click="exportDate">导出</el-button>
            </el-form-item>
          </el-form>
        </div>
        <main>
          <Table @on-to-stop-detail="onToStopDetailTop100Company" :allData="allData" />
        </main>
        <div class="block" style="width: fit-content; margin-left: auto; margin-right: auto;">
          <el-pagination @current-change="changeData" :current-page.sync="currentPage" :page-size="pageSize" layout="prev, pager, next, jumper" :total="total" slot="pagin"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Table from './components/table' // 表格数据
import http from '@/api/freight.js' //请求汇总
import exportDate from '@/components/exportDate/index'
import { hideExport } from '@/utils/tools'
import {
  getGasStationDropBox,
  getGasStationLabelByBrand,
} from '@/utils/dictionary'
import dimensionDialog from '@/components/exportDate/daphne/dialog.vue'
import dimensionPopover from '@/components/exportDate/daphne/popover.vue'
import Top100CompanyTable from './components/top100CompanyTable.vue'
import get from 'lodash/get'

var now = new Date()
now.setMonth(now.getMonth() - 1)
export default {
  components: {
    Table,
    exportDate,
    dimensionDialog,
    dimensionPopover,
    Top100CompanyTable
  },
  props: {
    areaList: Array,
    provinceName: String,
    pathWayCityName: String,
    brandName: String,
    dimObj: {
      default: () => {
        return {
          year: '2022',
          month: '02',
          type: '0',
        }
      },
      type: Object,
    },
  },
  data() {
    let titleArr = getGasStationDropBox()
    return {
      hideExport: hideExport,
      moduleName: 'oilCollectionStat',
      showExport: false,
      cityData: [],
      /*titleArr: [
        { name: '所有油站', code: 0 },
        { name: '中国石油', code: 1 },
        { name: '中国石化', code: 2 },
        { name: '其他油站', code: 3 }
      ],*/
      titleArr,
      oilBrand: '',
      cityName: '',
      provinceNames: '',
      progressNum: 0, // 导出下载进度条
      currentPage: 1,
      total: 0,
      pageSize: 20,
      allData: [], // 总数据
      showTop100Company: false,
      poiId:''
    }
  },
  created() {
    if (this.provinceName) {
      this.provinceNames = this.provinceName
      this.isPrivice(this.provinceName)
    }
    this.cityName = this.pathWayCityName
    this.oilBrand = this.brandName
    this.initData()
  },
  methods: {
    getBrandCode(name) {
      this.oilBrand = name
    },
    goback() {
      this.$emit('closeHtml')
    },
    submitData() {
      this.currentPage = 1
      this.initData()
    },
    changeData() {
      let that = this
      this.initData()
    },
    isPrivice(e) {
      if (e) {
        let that = this
        http.getCityList({ provname: e }).then((e) => {
          that.cityData = e.data
        })
      }
    },
    getCityList(e) {
      let that = this
      if (e) {
        http.getCityList({ provname: e }).then((e) => {
          that.cityData = e.data
          that.cityName = ''
        })
      } else {
        this.cityData = []
        this.cityName = ''
      }
    },
    getCityName(e) {
      this.cityName = e
    },
    initData() {
      let that = this
      that.allData = []
      let provinceName = that.provinceNames
      let cityName = that.cityName
      //let oilBrand = that.oilBrand == '所有油站' ? '' : that.oilBrand
      let tmp = getGasStationLabelByBrand(that.oilBrand)
      let oilBrand = tmp === '所有油站' ? '' : tmp
      let page = this.currentPage
      let pageSize = this.pageSize
      http
        .getDetailsList({
          countTime: this.dimObj.year + '' + this.dimObj.month,
          provinceName,
          cityName,
          oilBrand,
          page,
          pageSize,
          timeType: get(this, 'dimObj.type', '0'),
        })
        .then((e) => {
          if (e.data) {
            this.total = e.data.totalStripNum
            that.allData = [...e.data.resultList]
          }
        })
    },
    changeDimension(e) {
      if (e.isOk) {
        this.dimObj.year = e.year
        this.dimObj.month = e.month
        this.dimObj.type = e.type
        this.changeTime()
      }
    },
    changeTime() {
      this.initData()
    },
    initMonth(num) {
      let newNum = num + 1
      return newNum < 10 ? '0' + newNum : newNum + ''
    },
    beforeExportFunc(){
      if(!this.provinceNames){
        this.$message({
          message:  `请选择具体省份或城市进行油站信息导出`,
          type: 'warning'
        })
        return false
      }
      return true
    },
    // 取消导出
    hideExport1() {
      this.showExport = false
    },
    //导出
    exportDate() {
      this.showExport = true
    },
    onToStopDetailTop100Company(poiId){
      this.poiId = poiId
      this.showTop100Company = true
    }
  },
}
</script>